import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { insights } from "@/data/insights";

export const InsightsPreview = () => {
  return (
    <section
      data-testid="insights-section"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
              / 03 — Insights
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-2xl">
              Notes from the{" "}
              <span className="text-[#00FF66]">applied AI trenches.</span>
            </h2>
          </div>
          <Link
            to="/insights"
            data-testid="insights-see-all"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#00F0FF] transition-colors font-mono-label"
          >
            SEE ALL <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {insights.map((post, i) => (
            <article
              key={post.id}
              data-testid={`insight-card-${i}`}
              className="group rounded-2xl border border-white/10 bg-[#0F0F13] p-6 md:p-7 transition-transform duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-label text-[10px] text-[#00F0FF]">
                  {post.tag}
                </span>
                <span className="font-mono-label text-[10px] text-white/40">
                  {post.date}
                </span>
              </div>
              <h3 className="mt-6 font-display text-xl text-white tracking-tight leading-snug group-hover:text-[#00F0FF] transition-colors">
                {post.title}
              </h3>
              <p className="mt-3 text-sm text-white/55 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-6 font-mono-label text-[10px] text-white/40">
                {post.readTime}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsPreview;
